import { Pagination } from "@mantine/core";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import classes from "./PageChange.module.css";
import { LeftIcon } from "../Icons";

interface Props {
  total: number;
  activePage: number;
  setActivePage: (page: number) => void;
  className?: string;
  selectPerPage?: boolean;
  setPerPage?: (perPage: number) => void;
}

const ChangeButton = ({
  dir,
  onClick,
  className,
}: {
  dir: "left" | "right";
  onClick: () => void;
  className?: string;
}) => {
  const icon = <LeftIcon key={dir + "-icon"} className={`${classes.icon}`} width="20" />;
  const text = (
    <p key={dir + "-text"} className={classes.text}>
      {dir === "left" ? "Previous" : "Next"}
    </p>
  );

  return (
    <button
      className={`${classes.changeButton} ${className} ${
        dir === "right" ? classes.right : ""
      }`}
      onClick={onClick}
    >
      {dir === "left" ? [icon, text] : [text, icon]}
    </button>
  );
};

const PageChange = ({
  total,
  activePage,
  setActivePage,
  className,
  selectPerPage = false,
  setPerPage,
}: Props) => {
  const [pageInput, setPageInput] = useState("");
  const classNames = [classes.PageChange, className];
  const [itemCount, setItemCount] = useState<number>(20);

  const changePageHandler = (dir: "left" | "right") => {
    if (dir === "left" && activePage > 0) {
      setActivePage(activePage - 1);
    } else if (dir === "right" && activePage < total) {
      setActivePage(activePage + 1);
    }
  };

  const pageInputChange = (input: string) => {
    const value = parseInt(input);

    if (pageInput.length > 0) {
      if (value <= 0) {
        setPageInput("0");
      } else if (value > total) {
        setPageInput(total.toString());
      } else {
        setPageInput(input);
      }
    } else {
      setPageInput(input);
    }
  };

  const pageInputSubmit = () => {
    const value = parseInt(pageInput);
    if (pageInput.length > 0 && value <= total && value > 0) {
      // setActivePage(value - 1);
      setActivePage(value);
    }
  };

  return (
    <div className={classNames.join(" ")}>
      <div className={classes.left}>
        <ChangeButton
          dir="left"
          className={classes.changeButton}
          onClick={() => changePageHandler("left")}
        />

        {/* {pages.map((pageNo, index) => (
                    <ButtonPrimary key={index}
                        active={activePage === (pageNo - 1)}
                        type="outline"
                        className={classes.selectButton}
                        onClick={() => setActivePage(pageNo - 1)}
                    >
                        {pageNo}
                    </ButtonPrimary>
                ))} */}

        <Pagination
          value={activePage}
          onChange={(page) => {
            setActivePage(page);
          }}
          total={total}
          siblings={1}
          withControls={false}
          color="#F26E21"
          className="!text-white"
          style={{
            color: "black",
          }}
        />

        <ChangeButton
          dir="right"
          className={classes.changeButton}
          onClick={() => changePageHandler("right")}
        />
      </div>

      <div className={classes.right}>
        <p className={classes.text}>Total {total} pages</p>
        <div className={classes.btnText}>
          <p className={classes.text}>Go to pages</p>
        </div>

        <form
          className={classes.pageForm}
          onSubmit={(e) => {
            e.preventDefault();
            pageInputSubmit();
          }}
        >
          <input
            type="text"
            className={classes.input}
            value={pageInput}
            max={total}
            onChange={(e) => pageInputChange(e.target.value.replace(/\D/g, ""))}
            style={{
              width: `${30 + (pageInput.length - 1) * 5}px`,
            }}
          />
          <button type="submit" className={classes.button}>
            Go
          </button>
        </form>
      </div>
      {(+pageInput > total || +pageInput < 1) && pageInput.length > 0 && (
        <p className={classes.error}>Invalid page number</p>
      )}

      {selectPerPage && setPerPage && (
        <div className="ms-4 flex gap-2 items-center">
          <label>Per Page: </label>
          <select
            
            className="text-sm py-1.5 px-2 rounded-md border bg-white"
            onChange={(e) => {
              setItemCount(Number(e.target.value));
              setPerPage(Number(e.target.value));
            }}
            value={itemCount}
          >
            <option value={20}>20</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
          </select>
        </div>
      )}
    </div>
  );
};

export default PageChange;
